import { useState } from 'react'
import { ContactInviteSection } from '../components/ContactInviteSection'
import { HubHeader } from '../components/HubHeader'
import { ShareButtons } from '../components/ShareButtons'
import { WhatsAppIcon } from '../components/WhatsAppIcon'
import { useHubContext } from '../components/HubLayout'

function qrSrc(link: string): string {
  return `https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=${encodeURIComponent(link)}`
}

function videoEmbed(url: string): string | null {
  try {
    const parsed = new URL(url)
    if (parsed.hostname.includes('youtu.be')) {
      const id = parsed.pathname.replace('/', '')
      return id ? `https://www.youtube.com/embed/${id}` : null
    }
    if (parsed.hostname.includes('youtube.com')) {
      const id = parsed.searchParams.get('v')
      return id ? `https://www.youtube.com/embed/${id}` : null
    }
    if (parsed.hostname.includes('vimeo.com')) {
      const id = parsed.pathname.split('/').filter(Boolean).pop()
      return id ? `https://player.vimeo.com/video/${id}` : null
    }
  } catch {
    return null
  }
  return null
}

export function ConvidarPage() {
  const { hub, setError } = useHubContext()
  const [copyOk, setCopyOk] = useState('')

  if (!hub) return null

  const convite = hub.convite
  if (!convite?.convite) {
    return (
      <>
        <HubHeader title="Convidar" showLogo />
        <section className="bp-card">
          <p className="bp-card__eyebrow">Rede completa</p>
          <strong style={{ display: 'block', marginBottom: '0.35rem' }}>Você não pode convidar mais</strong>
          <p className="bp-muted" style={{ margin: 0 }}>
            Obrigado por participar! No nível 7 o convite fica desativado — continue engajando sua rede com Eu Apoio,
            Colinha e missões.
          </p>
        </section>
      </>
    )
  }

  const texto = convite.mensagem_whatsapp || `${convite.mensagem || ''}\n\n${convite.convite}`
  const embed = convite.video ? videoEmbed(convite.video) : null
  const campanhaNome = hub.campanha.nome || 'a campanha'

  async function copy(text: string, key: string) {
    try {
      await navigator.clipboard.writeText(text)
      setCopyOk(key)
      setTimeout(() => setCopyOk(''), 2000)
    } catch {
      setError('Não foi possível copiar.')
    }
  }

  return (
    <>
      <HubHeader
        title="Convidar"
        subtitle={`Chame apoiadores para ${campanhaNome}`}
        showCampanha
        showLogo
      />

      <section className="bp-card">
        <p className="bp-card__eyebrow">Comece por aqui</p>
        <strong style={{ display: 'block', fontSize: '1.05rem', marginBottom: '0.35rem' }}>
          Envie no WhatsApp
        </strong>
        <p className="bp-muted" style={{ margin: '0 0 0.85rem' }}>
          Um toque abre a conversa com seu link e a mensagem pronta.
        </p>
        <a className="bp-btn bp-btn--wa" href={convite.whatsapp} rel="noopener noreferrer">
          <WhatsAppIcon />
          Abrir WhatsApp
        </a>
        <div className="bp-stack" style={{ marginTop: '0.75rem' }}>
          <button type="button" className="bp-btn bp-btn--primary" onClick={() => copy(convite.convite, 'link')}>
            {copyOk === 'link' ? 'Link copiado!' : 'Copiar link'}
          </button>
          <button type="button" className="bp-btn" onClick={() => copy(texto, 'msg')}>
            {copyOk === 'msg' ? 'Mensagem copiada!' : 'Copiar mensagem completa'}
          </button>
        </div>
      </section>

      <section className="bp-card">
        <p className="bp-card__eyebrow">Seu link</p>
        <input className="bp-input" readOnly value={convite.convite} aria-label="Link de convite" />
        <p className="bp-muted" style={{ margin: '0.5rem 0 0', fontSize: '0.85rem' }}>
          Compartilhe também nas outras redes:
        </p>
        <ShareButtons url={convite.convite} title={hub.campanha.nome || 'Convite'} />
      </section>

      <ContactInviteSection message={texto} onError={setError} />

      <section className="bp-card" style={{ textAlign: 'center' }}>
        <p className="bp-card__eyebrow">QR Code</p>
        <p className="bp-muted" style={{ margin: '0 0 0.75rem' }}>
          Ideal para eventos e impressos — a pessoa aponta a câmera e cai no seu convite.
        </p>
        <img
          src={qrSrc(convite.convite)}
          alt="QR do convite"
          width={220}
          height={220}
          style={{ maxWidth: '100%', height: 'auto' }}
        />
        <a className="bp-btn" href={qrSrc(convite.convite)} target="_blank" rel="noreferrer" style={{ marginTop: '0.75rem' }}>
          Baixar QR
        </a>
      </section>

      {hub.campanha.logo ? (
        <section className="bp-card">
          <p className="bp-card__eyebrow">Imagem da campanha</p>
          <div className="bp-preview">
            <img src={hub.campanha.logo} alt={hub.campanha.nome} />
          </div>
        </section>
      ) : null}

      {convite.mensagem ? (
        <section className="bp-card">
          <p className="bp-card__eyebrow">Mensagem sugerida</p>
          <p style={{ whiteSpace: 'pre-wrap', margin: 0 }}>{convite.mensagem}</p>
        </section>
      ) : null}

      {convite.video ? (
        <section className="bp-card">
          <p className="bp-card__eyebrow">Vídeo</p>
          {embed ? (
            <iframe
              className="bp-video"
              src={embed}
              title="Vídeo da campanha"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <video className="bp-video" controls src={convite.video}>
              Seu navegador não reproduz este vídeo.
            </video>
          )}
          <a className="bp-btn" href={convite.video} target="_blank" rel="noreferrer" style={{ marginTop: '0.75rem' }}>
            Abrir vídeo
          </a>
        </section>
      ) : null}
    </>
  )
}
